/**
 * Formats a configuration-generation failure without exposing server internals.
 * The reference lets support correlate the portal failure with the Backend log.
 */
export function formatGenerationError(error: any, fallback: string): string {
  const payload = error?.error;
  const message =
    (typeof payload === 'string' ? normalizeGenerationMessage(payload) :
      payload?.Message || payload?.message || payload?.detail || payload?.title ||
      payload?.error?.Message || payload?.error?.message) ||
    error?.Message || error?.message || fallback;
  const correlationId =
    payload?.correlationId || error?.headers?.get?.('X-Correlation-ID');

  return correlationId ? `${message} Reference: ${correlationId}` : message;
}

/** Unwraps JSON-encoded string errors while leaving ordinary response text unchanged. */
function normalizeGenerationMessage(message: string): string {
  const trimmed = message?.trim();
  if (!trimmed) return '';
  try {
    const parsed = JSON.parse(trimmed);
    if (typeof parsed === 'string') return parsed;
    return parsed?.Message || parsed?.message || parsed?.detail || parsed?.title || trimmed;
  } catch {
    return trimmed;
  }
}
